/**
 * Shared client-side constants.
 *
 * Keep this surface small — anything that has business semantics
 * belongs in a service module, not here. Cookie key names and
 * route paths are the kind of "magic strings" that should live in
 * exactly one place.
 */

export const COOKIE_KEYS = {
  ACCESS_TOKEN: "_monago_access_token",
  REFRESH_TOKEN: "_monago_refresh_token",
  WORKSPACE_ID: "_monago_workspace_id",
} as const;

export const ROUTES = {
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  API_KEYS: "/api-keys",
  OBSERVABILITY: "/observability",
  POLICIES: "/policies",
  ASSETS: "/assets",
  RISK: "/risk",
  COMPLIANCE: "/compliance",
  EVALUATION: "/evaluation",
  PROVIDERS: "/providers",
  SKILLS: "/skills",
  WORKSPACES: "/workspaces",
  PLAYGROUND: "/playground",
  SETTINGS: "/settings",
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_TENANT: "/settings/tenant",
  SETTINGS_USERS: "/settings/users",
  SETTINGS_FX_RATE: "/settings/fx-rate",
  SETTINGS_ALLOWED_ORIGINS: "/settings/allowed-origins",
  SETTINGS_DATA_PROTECTION: "/settings/data-protection",
  /** Super-admin only — cross-tenant tenant-provisioning panel.
   *  Hidden from nav for non-super; route guard redirects manual
   *  URL access. BE enforces 403 on every endpoint. */
  PLATFORM_TENANTS: "/platform/tenants",
  /** Deprecated path retained for backward compat; redirected
   *  to ``PROVIDERS`` after Sesi POLISH-NAV-API (v0.29.0). */
  SETTINGS_PROVIDERS: "/settings/providers",
  NOT_FOUND: "/404",
} as const;

// 30 days for the refresh-token cookie; access-token cookie inherits
// the JWT's own 15-minute TTL (managed via the auto-refresh hook).
export const COOKIE_EXPIRY_DAYS = 30;
